/**
 * Convertit un nombre en lettres en français
 * @param {number} num - Le nombre à convertir
 * @returns {string} - Le nombre en lettres
 */
export function numberToWords(num) {
  const ones = ['', 'un', 'deux', 'trois', 'quatre', 'cinq', 'six', 'sept', 'huit', 'neuf'];
  const tens = ['', '', 'vingt', 'trente', 'quarante', 'cinquante', 'soixante', 'soixante-dix', 'quatre-vingts', 'quatre-vingt-dix'];
  const teens = ['dix', 'onze', 'douze', 'treize', 'quatorze', 'quinze', 'seize', 'dix-sept', 'dix-huit', 'dix-neuf'];
  
  const scales = [
    { value: 1000000000, name: 'milliard' },
    { value: 1000000, name: 'million' },
    { value: 1000, name: 'mille' },
    { value: 100, name: 'cent' }
  ];

  if (num === 0) return 'zéro';
  if (num < 0) return 'moins ' + numberToWords(-num);

  let result = '';

  for (const scale of scales) {
    if (num >= scale.value) {
      const count = Math.floor(num / scale.value);
      num %= scale.value;

      if (scale.value === 100) {
        if (count === 1) {
          result += 'cent';
        } else {
          result += ones[count] + ' ' + scale.name;
        }
      } else if (scale.value === 1000) {
        if (count === 1) {
          result += 'mille';
        } else {
          result += convertHundred(count, ones, tens, teens) + ' ' + scale.name;
        }
      } else {
        result += convertHundred(count, ones, tens, teens) + ' ' + scale.name;
      }

      if (num > 0) result += ' ';
    }
  }

  if (num > 0) {
    result += convertHundred(num, ones, tens, teens);
  }

  return result.trim();
}

/**
 * Convertit un nombre inférieur à 100 en lettres
 */
function convertHundred(num, ones, tens, teens) {
  let result = '';

  const hundred = Math.floor(num / 100);
  const remainder = num % 100;

  if (hundred > 0) {
    if (hundred === 1) {
      result += 'cent';
    } else {
      result += ones[hundred] + ' cents';
    }
    if (remainder > 0) result += ' ';
  }

  if (remainder >= 10 && remainder < 20) {
    result += teens[remainder - 10];
  } else {
    const ten = Math.floor(remainder / 10);
    const one = remainder % 10;

    if (ten > 0) {
      result += tens[ten];
      if (one > 0) {
        if (ten === 2 || ten === 3 || ten === 5 || ten === 7) {
          result += '-' + ones[one];
        } else {
          result += ' ' + ones[one];
        }
      } else if (ten === 8 || ten === 4 || ten === 6 || ten === 9) {
        result += 's';
      }
    } else if (one > 0) {
      result += ones[one];
    }
  }

  return result.trim();
}

/**
 * Convertir un montant en FCFA en lettres
 * @param {number} amount - Le montant en FCFA
 * @returns {string} - Le montant en lettres formaté
 */
export function amountToWords(amount) {
  const wholeAmount = Math.floor(amount);
  const wordsAmount = numberToWords(wholeAmount);
  return wordsAmount.charAt(0).toUpperCase() + wordsAmount.slice(1);
}
